import { Injectable, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Router, CanActivate } from '@angular/router';
//import { environment } from '../../environments/environment';
import { NgxSpinnerService } from "ngx-spinner";

const STORAGE_KEY = '24ieye';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

public baseUrl: any;
public ip: any;

  constructor(private httpClient: HttpClient, private router: Router, private titleService: Title, private spinner: NgxSpinnerService, @Inject('BASE_URL') baseUrl: string) { 
    this.baseUrl = baseUrl;
  }
  
  canActivate(): boolean {
//      console.log(this.login.get_session_data('ieye_session_id'));
    if (this.get_session_data('ieye_session_id') === null) {
        this.router.navigate(['login']);
        return false; 
    } else {
        return true;
    }
  }
  
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  
  get_session_data(key) {
    const result = localStorage.getItem(key);
    return result;
  }
  
  public async do_logout() {
    localStorage.clear();
    this.router.navigate(['login']);
  }
  
  get_app_action_url(key){
      var urls = {
          login: this.baseUrl + '/login',
          forgot_password: this.baseUrl + '/login/forgot-password',
          log: this.baseUrl + '/actions/add'
      }
      return urls[key]; 
  }
  
  public create_log(user, action){
      var input = {user_id: user, action: action} 
      return new Promise(resolve => {
      this.httpClient.post(this.get_app_action_url('log'), input).subscribe((res: any) => {
        
      }, err => {
        resolve('Opps! There is something went wrong!');
      });
    });
  }
  
  public get_ip_address(){
      const ipAPI = '//api.ipify.org?format=json';
      return fetch(ipAPI).then(response => response.json()).then((val) => { val.ip; });;
      return new Promise(resolve => {
        this.httpClient.get(ipAPI).subscribe((res: any) => {
            resolve(res);
        }, err => {
          resolve('Opps! There is something went wrong!');
        });
    });
  }
  
  public async form_actions(data, key) {  
    this.spinner.show();
    return new Promise(resolve => {
      this.httpClient.post(this.get_app_action_url(key), data).subscribe((res: any) => {
        this.spinner.hide();
        if (res.error == false) {
          resolve(res);
        } else {
          resolve(res);
        }
      }, err => {
        this.spinner.hide();
        resolve('Opps! There is something went wrong!');
      });
    });
  }
  
}
